import { createUseStyles } from 'react-jss'
import { BLACK, WHITE, DARK_GRAY_20, DARK_GRAY_05 } from '@omnilert/components'

export default createUseStyles({
  button: {
    backgroundColor: DARK_GRAY_20,
    border: 'none',
    borderRadius: 20,
    color: WHITE,
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '-0.02em',
    padding: '4px 10px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  buttonText: {
    marginRight: '5px'
  },
  headerText: {
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '-0.02em'
  },
  reportHeader: {
    borderBottom: `1px solid ${DARK_GRAY_05}`,
    color: WHITE,
    fontFamily: 'BentonSansBold',
    fontSize: '18px'
  },
  reportBody: {
    paddingBottom: '5px',
    paddingTop: '5px'
  },
  reportFooter: {
    borderTop: `1px solid ${DARK_GRAY_05}`,
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '5px'
  },
  icon: {
    '--icon__primary__stroke__color': WHITE
  },
  files: {
    display: ({ isExpanded }) => (isExpanded ? 'flex' : 'none'),
    justifyContent: 'flex-end',
    marginTop: '15px'
  },
  imageContainer: {
    display: 'flex',
    '&:not(:first-child)': { marginLeft: '10px !important' },
    height: '90px',
    width: '90px'
  },
  image: {
    borderRadius: '5px',
    backgroundColor: BLACK,
    height: '90px',
    border: ['2px', 'solid', WHITE],
    boxShadow: '0px -1px 23px -9px rgba(0,0,0,0.74)',
    objectFit: 'cover',
    width: '100%'
  },
  videoContainer: {
    display: 'flex',
    height: '90px',
    objectFit: 'cover',
    width: '90px'
  },
  video: {
    borderRadius: '5px !important',
    border: ['2px', 'solid', WHITE],
    backgroundColor: BLACK,
    height: '100%',
    width: '100%'
  }
})
